var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircularCheckbox22Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.2C16.6334 21.2 21.2 16.6334 21.2 11C21.2 5.36674 16.6334 0.800049 11 0.800049C5.36674 0.800049 0.800049 5.36674 0.800049 11C0.800049 16.6334 5.36674 21.2 11 21.2Z",
    stroke: "#151B26",
    strokeWidth: 1.36
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularCheckbox22Px);
export default ForwardRef;